export enum EmployeeType {
  None = 0,
  SupportStaff = 1,
  ProfessionalStaff = 2
}